import { IUserAdminBluePrint, userAdminQuery, userQuery } from "hooks/user/types";
import { UserFields } from "typed-response/src/example";
import { IAdminRole, IUser } from "utils/types";

export interface ILoginRequest {
    email: string;
    phone: string;
    password: string;
    isAdmin?: boolean
}
export interface ILoginResponse {
    accessToken: string;
    userId: string
    user: IUser;
}
export interface ILoginResponseBluePrint {
    user: UserFields;
    userAdmin: IUserAdminBluePrint;
}
export const loginResponseBluePrint:ILoginResponseBluePrint = {
    user: userQuery,
    userAdmin: userAdminQuery,
}
export interface IChangePasswordRequest {
    userId: string;
    oldPassword: string;
    newPassword: string
}
export interface IChangePasswordResponse {
    success: boolean;
}
export interface IResetPasswordRequest {
    email: string;
    phone: string;
    password: string;
}
export interface IResetPasswordResponse {
    success: boolean;
}
export interface IVerifyOTPRequest {
    email: string;
    phone: string;
    token: string;
}
export interface IVerifyOTPResponse {
    otpVerifiedToken: string
}
export interface ISendOTPRequest {
    email: string;
    phone: string;
}
export interface ISendOTPResponse {
    success: boolean;
    otp: string;
}
export interface ISignUpRequest {
    user: Partial<IUser>;
    password: string;
    accessToken?: string;
    adminRole?: IAdminRole
}
export interface ISignUpResponse {
    accessToken: string;
    userId: string;
    user: IUser;
}
